import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { IconTrendComment } from 'svgIcons/MotionPortalIcons';
import IconCollapse from 'svgIcons/MotionPortalIcons/IconCollapse';
import { translate } from 'helpers/translateHelper';
import './style.scss';
import TrendCommentsDrawer from './TrendCommentsDrawer';
import TrendCommentsModal from './TrendCommentsModal';
import TrendCommentsDeleteModal from './TrendCommentsDeleteModal';
import TrendCommentsHelpModal from './TrendCommentsHelpModal';

const TrendCommentsComponent = (props) => {
    const { model, actions } = props;
    const {
        isTrendCommentsDrawerVisible,
        isTrendCommentsModalVisible,
        trendCommentsList,
        trendCommentsCreateEditLoadingStatus,
        trendCommentsDeleteLoadingStatus,
        editCommentData,
        selectedAsset,
        selectedTrendKPIs,
        trendKPIsList,
        trendCommentsListLoadingStatus,
        graphCommentTimestamp,
        selectedTrendCommentsList,
        selectedDataPointTimestamp,
        energyRelatedKPIsList,
        user,
        trendCommentsCreateEditErrorData,
        trendCommentsDeleteErrorData
    } = model;
    const {
        setTrendCommentsDrawerVisible,
        setTrendCommentsModalVisible,
        createAndEditTrendCommentRequest,
        clearCreateEditTrendCommentError,
        deleteTrendCommentRequest,
        clearDeleteTrendCommentError,
        resetTrendCommentSelection
    } = actions;

    const [deleteCommentId, setDeleteCommentId] = useState(null);
    const [isShowHelpModal, setIsShowHelpModal] = useState(false);

    return (
        <div className='trend-comment-container'>
            <button
                className='trend-comment-sidebar'
                type='button'
                onClick={() => setTrendCommentsDrawerVisible(true)}
                aria-label={translate('ABB.Powertrain.Frontend.openTrendComments')}
            >
                <div className='comment-title'>
                    <IconTrendComment />
                    <div className='title'>
                        {`${translate('ABB.Powertrain.Frontend.opTrendCommentsTitle')} (${trendCommentsList?.length ?? 0})`}
                    </div>
                </div>
                <button
                    type='button'
                    aria-label={'collapse sidebar'}
                    className={'column-sidebar-toggle-button'}
                >
                    <IconCollapse width={16} height={16} />
                </button>
            </button>
            <TrendCommentsDrawer
                isShowDrawer={isTrendCommentsDrawerVisible}
                setIsShowDrawer={setTrendCommentsDrawerVisible}
                setIsShowModal={setTrendCommentsModalVisible}
                trendCommentsList={selectedTrendCommentsList}
                setDeleteCommentId={setDeleteCommentId}
                trendCommentsListLoadingStatus={trendCommentsListLoadingStatus}
                trendKPIsList={[...trendKPIsList, ...energyRelatedKPIsList]}
                selectedDataPointTimestamp={selectedDataPointTimestamp}
                resetTrendCommentSelection={resetTrendCommentSelection}
                setIsShowHelpModal={setIsShowHelpModal}
            />
            {isTrendCommentsModalVisible &&
                <TrendCommentsModal
                    isShowModal={isTrendCommentsModalVisible}
                    setIsShowModal={setTrendCommentsModalVisible}
                    createAndEditTrendCommentRequest={createAndEditTrendCommentRequest}
                    clearCreateEditTrendCommentError={clearCreateEditTrendCommentError}
                    trendCommentsCreateEditLoadingStatus={trendCommentsCreateEditLoadingStatus}
                    trendCommentsCreateEditErrorData={trendCommentsCreateEditErrorData}
                    editCommentData={editCommentData}
                    selectedAsset={selectedAsset}
                    selectedTrendKPIs={selectedTrendKPIs}
                    trendKPIsList={[...trendKPIsList, ...energyRelatedKPIsList]}
                    graphCommentTimestamp={graphCommentTimestamp}
                    userEmail={user?.email}
                />
            }
            {deleteCommentId &&
                <TrendCommentsDeleteModal
                    commentID={deleteCommentId}
                    show={!!deleteCommentId}
                    close={() => setDeleteCommentId(null)}
                    loadingStatus={trendCommentsDeleteLoadingStatus}
                    errorData={trendCommentsDeleteErrorData}
                    deleteTrendCommentRequest={deleteTrendCommentRequest}
                    clearDeleteTrendCommentError={clearDeleteTrendCommentError}
                />
            }
            {isShowHelpModal &&
                <TrendCommentsHelpModal
                    isOpen={isShowHelpModal}
                    onClose={() => setIsShowHelpModal(false)}
                />
            }
        </div>
    );
};

TrendCommentsComponent.propTypes = {
    model: PropTypes.shape({
        isTrendCommentsDrawerVisible: PropTypes.bool,
        isTrendCommentsModalVisible: PropTypes.bool,
        trendCommentsList: PropTypes.array,
        trendCommentsCreateEditLoadingStatus: PropTypes.string,
        trendCommentsDeleteLoadingStatus: PropTypes.string,
        editCommentData: PropTypes.object,
        selectedAsset: PropTypes.object,
        selectedTrendKPIs: PropTypes.array,
        trendKPIsList: PropTypes.array,
        trendCommentsListLoadingStatus: PropTypes.string,
        graphCommentTimestamp: PropTypes.string,
        selectedTrendCommentsList: PropTypes.array,
        selectedDataPointTimestamp: PropTypes.string,
        energyRelatedKPIsList: PropTypes.array,
        user: PropTypes.object,
        trendCommentsCreateEditErrorData: PropTypes.shape({
            loadingStatus: PropTypes.string,
            errorCode: PropTypes.number,
            error: PropTypes.object
        }),
        trendCommentsDeleteErrorData: PropTypes.shape({
            loadingStatus: PropTypes.string,
            errorCode: PropTypes.number,
            error: PropTypes.object
        })
    }).isRequired,
    actions: PropTypes.shape({
        setTrendCommentsDrawerVisible: PropTypes.func.isRequired,
        setTrendCommentsModalVisible: PropTypes.func.isRequired,
        createAndEditTrendCommentRequest: PropTypes.func.isRequired,
        clearCreateEditTrendCommentError: PropTypes.func.isRequired,
        deleteTrendCommentRequest: PropTypes.func.isRequired,
        clearDeleteTrendCommentError: PropTypes.func.isRequired,
        resetTrendCommentSelection: PropTypes.func.isRequired
    }).isRequired
};

export default TrendCommentsComponent;
